import Vue from 'vue'

const formatModule = {
    state: {
        formatList: [],
        currentFormat: {}
    },
    mutations: {
        SET_FORMATS (state, newVal) {
            state.formatList = newVal
        },
        SET_CURRENT_FORMAT (sate, newVal) {
            state.currentFormat = newVal
        }
    },
    getters: {
        getFormats (state) {
            return state.formatList
        },
        getFormat (state) {
            return state.currentFormat
        }
    },
    actions: {
        async FETCH_FORMATS (ctx) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getFormats'
            )

            ctx.commit('SET_FORMATS', result.data)
        },
        async FETCH_FORMAT (ctx, id) {
            let result = await Vue.API.AmfRequest(
                'frechmann.Format',
                'getFormatById',
                id
            )

            ctx.commit('SET_CURRENT_FORMAT', result.data)
        }
    }
}

export const state = formatModule.state
export const getters = formatModule.getters
export const mutations = formatModule.mutations
export const actions = formatModule.actions
